module.exports = __webpack_public_path__ + "img/service-2.0b9ba330.svg";